if (!customElements.get('cart-item')) {
  class CartItem extends HTMLElement {
    constructor() {
      super();

      this.removeBtns = this.querySelectorAll('.js-variant-remove');
      this.cartItemPrice = this.querySelector('.js-cart-item-price');
      this.sellingPlanPrice = this.querySelector('.js-selling-plan-price');
      this.cartPrice = this.querySelector('.js-variant-price');
      this.comparePrice = this.querySelector('.js-compare-price');
      this.undoRemovedProductBtn = this.querySelector('.js-add-removed-product');
      this.removeMessageBtn = this.querySelector('.js-remove-message');
      this.drawerNote = document.querySelector('.js-cart-note');
      this.drawerFooter = document.querySelector('.js-cartdrawer-footer');
      this.drawerTable = this.querySelector('.js-cart-drawer-table');
      this.removeItemTrigger = this.querySelector('.js-remove-item-trigger');
      this.cart = document.querySelector('cart-drawer');
      this.subtotalCart = document.querySelectorAll('.js-cart-subtotal');
      this.totalPrice = document.querySelector('.js-drawer-total');
      this.totalProductCount = document.querySelectorAll('.js-cart-count');
      this.emptyCart = document.querySelectorAll('.js-drawer-empty-message');

      this.variantPrice = +this.dataset.price;
      this.removedItems = [];

      this.bindEvents();
    }

    bindEvents() {
      this.handleQtyInput();
      this.handleUndoRemovedProduct();
      this.handleRemoveMessage();
      this.handleUndoRemovedProductTrigger();

      this.onchange();

      this.removeBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.updateQuantity(Number(this.dataset.id), 0);
        });
      });
    }

    onchange() {
      this.addEventListener(
        'change',
        debounce((event) => {
          this.updateQuantity(Number(event.target.dataset.id), Number(event.target.value));
        })
      );
    }

    handleUndoRemovedProductTrigger() {
      if (!this.removeItemTrigger) return;
      this.removeItemTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleRemovingProduct();
      });
    }

    handleQtyInput() {
      const qtyControls = this.querySelector('.js-quantity-controls');
      if (!qtyControls) return;

      const qtyBtns = qtyControls.querySelectorAll('button');
      const inputQty = qtyControls.querySelector("input[type='number']");

      qtyBtns.forEach((btn) => {
        btn.addEventListener('click', (event) => {
          event.target.name === 'plus' ? inputQty.stepUp() : inputQty.stepDown();
          if (+inputQty.value === 0 && +this.dataset.drawer === 1) {
            this.handleRemovingProduct();
          } else {
            inputQty.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }

    handleRemovingProduct() {
      this.classList.add('removing');
      this.getRemovedItems(+this.dataset.id);
      this.handleTotalPrice();
      this.handleMinusCount();
    }

    handleUndoRemovedProduct() {
      if (!this.undoRemovedProductBtn) return;
      this.undoRemovedProductBtn.addEventListener('click', (e) => {
        e.preventDefault();

        const finalPrice = localCurrency.formatPrice(this.dataset.price);
        const totalPrice = +this.totalPrice.dataset.totalprice;
        const handleTotalPrice = totalPrice + +this.dataset.price;
        this.totalPrice.setAttribute('data-totalprice', handleTotalPrice);
        this.totalPrice.innerHTML = localCurrency.formatPrice(handleTotalPrice);
        this.cartPrice.innerHTML = finalPrice;

        const qtyControls = this.querySelector('.js-quantity-controls');
        const inputQty = qtyControls.querySelector("input[type='number']");
        inputQty.value = this.dataset.qty;

        const undoSuccessMessage = this.querySelector('.js-drawer-footer');
        this.classList.remove('removing');
        undoSuccessMessage.classList.add('undo-success');
        setTimeout(() => {
          undoSuccessMessage.classList.remove('undo-success');
        }, 1500);

        this.undoRemovedItems(+this.dataset.id);
        this.handlePlusCount();
      });
    }

    handleRemoveMessage() {
      if (!this.removeMessageBtn) return;
      this.removeMessageBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.remove();
        if (+this.totalPrice.dataset.totalprice === 0) {
          this.emptyCart.forEach((e) => {
            e.hidden = false;
          });
        }
      });
    }

    handleTotalPrice() {
      const totalPrice = +this.totalPrice.dataset.totalprice;
      const handleTotalPrice = totalPrice - this.variantPrice;
      this.totalPrice.setAttribute('data-totalprice', handleTotalPrice);
      this.totalPrice.innerHTML = localCurrency.formatPrice(handleTotalPrice);
    }

    handleMinusCount() {
      publishEvent(PUB_SUB_EVENTS.fakeQuantityUpdate, {
        source: 'cart-item',
        data: { quantity: Number(this.dataset.qty) * -1 }
      });
    }

    handlePlusCount() {
      publishEvent(PUB_SUB_EVENTS.fakeQuantityUpdate, {
        source: 'cart-item',
        data: { quantity: Number(this.dataset.qty) }
      });
    }

    updateQuantity(variantKey, quantity) {
      if (!variantKey) return;
      const data = {
        updates: {
          [variantKey]: quantity
        },
        sections: 'cart-drawer',
        sections_url: window.location.pathname
      };

      const body = JSON.stringify(data);

      this.cartItemPrice.classList.add('is-loading');

      fetch(`${window.routes.cart_update_url}`, {
        ...fetchConfig(),
        ...{ body }
      })
        .then((response) => response.json())
        .then((response) => {
          this.updateContent(response, quantity);

          publishEvent(PUB_SUB_EVENTS.quantityUpdate, {
            source: 'cart-item',
            data: { lineId: this.dataset.id, data: response }
          });

          if (response.description) console.warn(response.description);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.cartItemPrice.classList.remove('is-loading');
        });
    }

    updateContent(response, quantity) {
      if (quantity == 0) {
        this.updateTotalPrice(response.items_subtotal_price);
        this.remove();

        // Empty cart
        if (response.items.length == 0)
          publishEvent(PUB_SUB_EVENTS.emptyCart, {
            source: 'cart-item'
          });

        if (window.location.pathname == window.routes.cart_url && response.items.length == 0)
          window.location.reload();

        return;
      }

      const updatedVariant = response.items.find((item) => item.id == this.dataset.id);

      if (updatedVariant) {
        let finalPrice = localCurrency.formatPrice(updatedVariant.final_line_price),
          originPrice = localCurrency.formatPrice(updatedVariant.original_line_price);

        this.comparePrice.classList.remove('hidden');

        if (finalPrice == originPrice && this.comparePrice)
          this.comparePrice.classList.add('hidden');

        if (this.comparePrice) this.comparePrice.innerHTML = originPrice;
        if (this.cartPrice)
          originPrice != finalPrice
            ? (this.cartPrice.innerHTML = finalPrice)
            : (this.cartPrice.innerHTML = originPrice);

        this.setAttribute('data-price', updatedVariant.final_line_price);
        this.setAttribute('data-qty', updatedVariant.quantity);

        if (this.sellingPlanPrice) {
          let currentSellingPrice = localCurrency.formatPrice(
            updatedVariant?.selling_plan_allocation?.compare_at_price * quantity
          );
          this.sellingPlanPrice.innerHTML = currentSellingPrice;
        }

        this.updateTotalPrice(response.items_subtotal_price);
      }
    }

    updateTotalPrice(totalPrice) {
      if (this.subtotalCart && totalPrice) {
        this.subtotalCart.forEach((subTotal) => {
          subTotal.innerHTML = localCurrency.formatPrice(totalPrice);
        });
      }
    }

    getRemovedItems(id) {
      this.removedItems = JSON.parse(localStorage.getItem('removedItem')) || [];
      if (!this.removedItems.includes(id)) {
        this.removedItems.push(id);
      }

      localStorage.setItem('removedItem', JSON.stringify(this.removedItems));
    }
    undoRemovedItems(id) {
      const removedItems = JSON.parse(localStorage.getItem('removedItem'));
      const itemId = removedItems.indexOf(id);
      if (itemId > -1) {
        removedItems.splice(itemId, 1);
      }
      localStorage.setItem('removedItem', JSON.stringify(removedItems));
    }
  }

  customElements.define('cart-item', CartItem);
}
